import { url } from "utils/urls"

export const languages = [
  { id: 'EN', name: "English", value: 'EN', icon: `${url.image}/2.0/languages/EN.svg`},
  { id: 'ES', name: "Spanish", value: 'ES', icon: `${url.image}/2.0/languages/ES.svg`}
]

export const themePreview = {
  EN: {
    // commenting
    minutes: '5 mins',
    mostRecent: 'Most Recent',
    comments: 'Comments',
    joinConversation: 'Join the conversation...',
    post: 'Post',
    reply: 'Reply',
    comment: 'Comment',
    comment1: 'The horseman came beating the drum of the plains. The boy at the forge has his little eyes shut.',
    comment2: 'Crossing the river I pluck hibiscus-flowers: in the orchid-swamps are many fragrant herbs. I gather them, but who shall I send them to?',
    comment3: 'The horseman came beating the drum of the plains. The boy at the forge has his little eyes shut.',

    // trending now
    popular: 'Popular in the community',
    sampleTitle: 'Sample article headline from your site',
    views: 'views',

    // article sentiment
    sentimentHeader: 'What do you think?',
    totalReactions: 'Total Reactions'
  },
  ES: {
    // commenting
    minutes: 'hace 5 minutos',
    mostRecent: 'Más recientes',
    comments: 'Comentarios',
    joinConversation: 'Únete a la conversación...',
    post: 'Publicar',
    reply: 'Responder',
    comment: '',
    comment1: 'El jinete llegó tocando el tambor de las llanuras. El niño de la forja tiene los ojitos cerrados.',
    comment2: 'Cruzando el río, recojo flores de hibisco: en los pantanos de orquídeas hay muchas hierbas aromáticas. Las recojo, pero ¿a quién se las enviaré?',
    comment3: 'El jinete llegó tocando el tambor de las llanuras. El niño de la forja tiene los ojitos cerrados.',

    // trending now
    popular: 'Popular en la comunidad',
    sampleTitle: 'Ejemplo de título de artículo de su sitio',
    views: 'vistas',

    // article sentiment
    sentimentHeader: 'Qué piensas?',
    totalReactions: 'Reacciones totales'
  }
};
